import { useEffect, useState } from "react"
import { Stack, TextField, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material"

export function CostFixedAmountInput({ amount, onChange }) {
    const current = Number(amount) || 0
    // Held as a string so clearing the field doesn't snap back to a controlled 0 mid-type.
    const [localValue, setLocalValue] = useState(String(Math.abs(current)))
    const [selectedSign, setSelectedSign] = useState(current < 0 ? "-" : "+")

    useEffect(syncFromAmount, [amount])

    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <ToggleButtonGroup exclusive size="small" value={selectedSign} onChange={handleSignChange}>
                <ToggleButton value="+">+</ToggleButton>
                <ToggleButton value="-">&minus;</ToggleButton>
            </ToggleButtonGroup>
            <TextField
                size="small"
                type="number"
                value={localValue}
                onChange={handleValueChange}
                onBlur={handleBlur}
                onWheel={(e) => e.target.blur()}
                inputProps={{ min: 0, step: 1 }}
                sx={{ width: 120 }}
                data-cy="cost-modifier-fixed-amount"
            />
            <Typography variant="caption" color="text.secondary">
                added once to the scenario total when this rule matches
            </Typography>
        </Stack>
    )

    function syncFromAmount() {
        const nextAmount = Number(amount) || 0
        setLocalValue(String(Math.abs(nextAmount)))
        if (nextAmount !== 0) setSelectedSign(nextAmount < 0 ? "-" : "+")
    }

    function handleSignChange(_, newSign) {
        if (!newSign) return
        setSelectedSign(newSign)
        onChange(newSign === "-" ? -parsedValue() : parsedValue())
    }

    function handleValueChange(e) {
        setLocalValue(e.target.value)
    }

    function handleBlur() {
        onChange(selectedSign === "-" ? -parsedValue() : parsedValue())
    }

    function parsedValue() {
        const parsed = Math.abs(parseFloat(localValue))
        return Number.isFinite(parsed) ? parsed : 0
    }
}
